import { Controller } from '@hotwired/stimulus';

export const EVENTO_CONTROLLER_CARGADO = 'controller:cargado';

export default class extends Controller {
  lanzarEventoCargado() {
    const evento = new CustomEvent(EVENTO_CONTROLLER_CARGADO, {
      detail: {
        controller: this,
      },
    });
    this.element.dispatchEvent(evento);
  }

  /**
   * Obtiene un controlador Stimulus asociado a un elemento.
   * Si el controlador no está cargado, espera a que se cargue y lo devuelve.
   * @param {HTMLElement} elemento - El elemento del DOM al que se le busca el controlador.
   * @param {string} nombreController - El nombre del controlador Stimulus.
   * @returns {Promise} - Una promesa que se resuelve con el controlador Stimulus.
   */
  // eslint-disable-next-line class-methods-use-this
  getControllerAsync(elemento, nombreController) {
    let controller = window.Stimulus.getControllerForElementAndIdentifier(
      elemento,
      nombreController,
    );

    if (!controller) {
      return new Promise((resolve) => {
        elemento.addEventListener(EVENTO_CONTROLLER_CARGADO, (event) => {
          controller = event.detail.controller;

          resolve(controller);
        }, { once: true });
      });
    }

    return Promise.resolve(controller);
  }
}
